module.exports = __webpack_public_path__ + "static/media/logo_mensie.3b234538.png";